// extracted by mini-css-extract-plugin
export default {"link":"LogoutBtn_link__Y45RC"};